/* Pump Club — PDP enhancements.
   The "Deliver to / Enter pincode" widget is injected at runtime by a third-party app,
   above the breadcrumb. This relocates it to sit just below the Add-to-Cart block and
   tags it for restyling. Uses a MutationObserver so it catches late AND re-injected
   widgets (the app sometimes re-renders the widget back to the top on variant change). */
(function () {
  'use strict';

  function isOurOwnBox(el) {
    // never grab the theme's own shipping-timer "delivery date" box or the product form
    return !el ||
      el.matches('[class*="shipping_timer" i],[class*="delivery-alert" i],[class*="delivery-truck" i],[class*="delivery-date" i]') ||
      !!el.querySelector('.product-block-atc, product-form, [name="add"], [class*="shipping_timer" i]');
  }

  function findPincodeWidget() {
    var input = document.querySelector(
      'input[placeholder*="pincode" i], input[placeholder*="pin code" i], input[placeholder*="enter pin" i],' +
      'input[placeholder*="postal" i], input[placeholder*="zip" i], input[placeholder*="area pin" i]'
    );
    if (input) {
      // climb to the smallest ancestor that looks like the whole widget (has the input + a check button/label)
      var el = input, hops = 0, best = input.closest('div') || input.parentElement;
      while (el && el.parentElement && hops < 6) {
        el = el.parentElement; hops++;
        var t = (el.textContent || '');
        if (/deliver|pincode|pin\s?code|estimat|check\s*availab|delivery\s*by/i.test(t) && t.length < 400) best = el;
      }
      if (best && !isOurOwnBox(best)) return best;
    }
    // text-based fallback: a small block that says "Deliver to" / "Check delivery" AND owns an input
    var nodes = document.querySelectorAll('div, section, form');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i], txt = (n.textContent || '').slice(0, 80);
      if (n.querySelector('input') && /deliver to|check delivery|enter pincode|check availab/i.test(txt) && !isOurOwnBox(n)) {
        return n;
      }
    }
    return null;
  }

  function relocate() {
    var widget = findPincodeWidget();
    var atc = document.querySelector('.product-block-atc');
    if (!widget || !atc) return false;
    if (widget.dataset.pcMoved === '1' && widget.previousElementSibling === atc) return true; // already in place
    widget.dataset.pcMoved = '1';
    widget.classList.add('pc-pincode-relocated');
    atc.parentNode.insertBefore(widget, atc.nextSibling);
    return true;
  }

  function init() {
    relocate();
    // watch for late injection / re-injection by the app, then settle.
    var settleTimer = null;
    var obs = new MutationObserver(function () {
      if (settleTimer) return;
      settleTimer = setTimeout(function () { settleTimer = null; relocate(); }, 120);
    });
    try { obs.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    // hard stop after 30s so we don't observe forever
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 30000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
